import { ILanguage } from "@gisce/oficina-virtual-components";


export const REGISTERED_LANGUAGES = [
  { value: "ca-ES", langCode: "ca", display: "Català", displayShort: "CAT" },
  { value: "oc-ES", langCode: "oc", display: "Aranés", displayShort: "ARN" },
  { value: "gl-ES", langCode: "gl", display: "Galego", displayShort: "GAL" },
  { value: "eu-ES", langCode: "eu", display: "Euskara", displayShort: "EUS" },
  { value: "es-ES", langCode: "es", display: "Español", displayShort: "ESP" },
  { value: "en-US", langCode: "en", display: "English", displayShort: "ENG" },
] as const satisfies ILanguage[];

export type RegisteredLangNames = (typeof REGISTERED_LANGUAGES)[number]["value"];
